import React, { useState } from 'react'
import { SmartInsightsAIRecommendations } from 'src/charts/SmartInsightsAIRecommendations'
import {
  mockSmartInsightsFullData,
  mockSmartInsightsSparseData,
  mockSmartInsightsEmptyData,
  mockSmartInsightsSingleCategory,
} from 'src/mocks/smartInsightsMockData'
import styles from './smartInsightsTest.module.scss'

type MockDataType = 'full' | 'sparse' | 'empty' | 'single'

export const SmartInsightsTest = () => {
  const [selectedMock, setSelectedMock] = useState<MockDataType>('sparse')

  const getMockData = () => {
    switch (selectedMock) {
      case 'full':
        return mockSmartInsightsFullData
      case 'sparse':
        return mockSmartInsightsSparseData
      case 'empty':
        return mockSmartInsightsEmptyData
      case 'single':
        return mockSmartInsightsSingleCategory
      default:
        return mockSmartInsightsSparseData
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.controls}>
        <h1>Smart Insights Test Page</h1>
        <p>
          Test the min-height fix: Switch between categories to verify the
          widget maintains height even with fewer than 3 items.
        </p>
        <div className={styles.buttons}>
          <button
            className={selectedMock === 'full' ? styles.active : ''}
            onClick={() => setSelectedMock('full')}
            type="button"
          >
            Full Data (3+ items per category)
          </button>
          <button
            className={selectedMock === 'sparse' ? styles.active : ''}
            onClick={() => setSelectedMock('sparse')}
            type="button"
          >
            Sparse Data (1-2 items per category)
          </button>
          <button
            className={selectedMock === 'single' ? styles.active : ''}
            onClick={() => setSelectedMock('single')}
            type="button"
          >
            Single Category Only
          </button>
          <button
            className={selectedMock === 'empty' ? styles.active : ''}
            onClick={() => setSelectedMock('empty')}
            type="button"
          >
            Empty Data
          </button>
        </div>
      </div>

      <SmartInsightsAIRecommendations data={getMockData()} isLoading={false} />
    </div>
  )
}
